import firebase from 'firebase/app'
import { config } from './config';

let inited = false;

export const initFirebase = () => {
    if (inited) return;
    firebase.initializeApp(config);
    inited = true;
    console.log('Firebase inited');
}
